import { createFileRoute } from "@tanstack/react-router";
import { ForgotPasswordForm } from "@/features/auth/ForgotPasswordForm";

export const Route = createFileRoute("/forgot-password")({
  component: ForgotPasswordPage,
});

function ForgotPasswordPage() {
  return (
    <div className="bg-arc-gray-50 flex min-h-screen items-center justify-center px-4 py-16">
      <ForgotPasswordForm />
    </div>
  );
}
